module.exports = __webpack_public_path__ + "img/default-mobile-arabic.eb2b8821.png";